export default {
  title: {
    notes: 'Filter modal title',
    message: 'Filter',
  },
  resetButton: {
    notes: 'Clear filters button title',
    message: 'Clear filters',
  },
  closeButton: {
    notes: 'Close filter modal (only close, filters are already applied)',
    message: 'Close',
  },
};
